/* eslint-disable */
import SHA1 from "crypto-js/sha1";

const INFO_SALT = ["vaBci", "l6AF8", "vM9vH"];

export const sha1Encrypt = (source: string) => {
  const saltLength = INFO_SALT.length;
  const splitLength = Math.floor(source.length / saltLength);
  let tempSource = "";

  for (let i = 0; i < saltLength; i++) {
    if (i === saltLength - 1) {
      tempSource += source.substring(splitLength * i, source.length);
      tempSource += INFO_SALT[i];
    } else {
      tempSource += source.substring(splitLength * i, splitLength * (i + 1));
      tempSource += INFO_SALT[i];
    }
  }
  return SHA1(tempSource).toString();
};

export function replaceNameWithAsterisk(name) {
  const nameLength = name.length;
  if (nameLength <= 1) {
    return name;
  }
  const replacedName = "*".repeat(nameLength - 1) + name.slice(-1);

  return replacedName;
}

export function maskNumber(number) {
  const numberStr = number.toString();
  const numberLength = numberStr.length;
  if (numberLength <= 6) {
    return number;
  }
  const maskedNumber =
    numberStr.slice(0, 3) + "*".repeat(numberLength - 6) + numberStr.slice(-3);

  return maskedNumber;
}
